<template>
  <div class="home py-5">
    <div class="form-container">
      <v-col>
        <v-row class="ma-10">
          <span>Abandonned Checkouts : </span>
          <v-row v-if="ressourceLoading.abandonned_checkout != true">
            <v-btn class="mx-6" @click="sync('abandonned_checkout')">Sync abandonned checkouts</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.abandonned_checkout)">Synced : {{ressourceLoading.abandonned_checkout}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Ambassador : </span>
          <v-row v-if="ressourceLoading.ambassador != true">
            <v-btn class="mx-6" v-if="ressourceLoading.ambassador != true" @click="sync('ambassador')">Sync ambassadors</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.ambassador)">Synced : {{ressourceLoading.ambassador}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Appellations : </span>
          <v-row v-if="ressourceLoading.appellation != true">
            <v-btn class="mx-6" v-if="ressourceLoading.appellation != true" @click="sync('appellation')">Sync appellations</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.appellation)">Synced : {{ressourceLoading.appellation}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Companies : </span>
          <v-row v-if="ressourceLoading.company != true">
            <v-btn class="mx-6" v-if="ressourceLoading.company != true" @click="sync('company')">Sync companies</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.company)">Synced : {{ressourceLoading.company}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Countries : </span>
          <v-row v-if="ressourceLoading.country != true">
            <v-btn class="mx-6"  @click="sync('country')">Sync countries</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.country)">Synced : {{ressourceLoading.country}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Domains : </span>
          <v-row v-if="ressourceLoading.domain != true">
            <v-btn class="mx-6" v-if="ressourceLoading.domain != true" @click="sync('domain')">Sync domains</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.domain)">Synced : {{ressourceLoading.domain}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Discount Codes : </span>
          <v-row v-if="ressourceLoading.discount_code != true">
            <v-btn class="mx-6" v-if="ressourceLoading.discount_code != true" @click="sync('discount_code')">Sync Discount Code</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.discount_code)">Synced : {{ressourceLoading.discount_code}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Grapes : </span>
          <v-row v-if="ressourceLoading.grape != true">
            <v-btn class="mx-6" v-if="ressourceLoading.grape != true" @click="sync('grape')">Sync Grapes</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.grape)">Synced : {{ressourceLoading.grape}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Grape Varieties : </span>
          <v-row v-if="ressourceLoading.grape_variety != true">
            <v-btn class="mx-6" v-if="ressourceLoading.grape_variety != true" @click="sync('grape_variety')">Sync Grape Varieties</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.grape_variety)">Synced : {{ressourceLoading.grape_variety}}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Legal Entity Types : </span>
          <v-row v-if="ressourceLoading.legal_entity_type  != true">
            <v-btn class="mx-6" v-if="ressourceLoading.legal_entity_type != true" @click="sync('legal_entity_type')">Sync Legal Entity Types</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.legal_entity_type )">Synced : {{ressourceLoading.legal_entity_type }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Orders : </span>
          <v-row v-if="ressourceLoading.order  != true">
            <v-btn class="mx-6" v-if="ressourceLoading.order != true" @click="sync('order')">Sync Orders</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.order)">Synced : {{ressourceLoading.order }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Regions : </span>
          <v-row v-if="ressourceLoading.region  != true">
            <v-btn class="mx-6" v-if="ressourceLoading.region != true" @click="sync('region')">Sync Region</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.region)">Synced : {{ressourceLoading.region }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Super Ambassadors : </span>
          <v-row v-if="ressourceLoading.super_ambassador  != true">
            <v-btn class="mx-6" v-if="ressourceLoading.super_ambassador != true" @click="sync('super_ambassador')">Sync Super Ambassadors</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.super_ambassador)">Synced : {{ressourceLoading.super_ambassador }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Users : </span>
          <v-row v-if="ressourceLoading.user  != true">
            <v-btn class="mx-6" v-if="ressourceLoading.user != true" @click="sync('user')">Sync Users</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.user)">Synced : {{ressourceLoading.user }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Wines : </span>
          <v-row v-if="ressourceLoading.wine != true">
            <v-btn class="mx-6" v-if="ressourceLoading.wine != true" @click="sync('wine')">Sync Wines</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.wine)">Synced : {{ressourceLoading.wine }}</span>
          </v-row>

          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
        <v-row class="ma-10">
          <span>Wine Templates : </span>
          <v-row v-if="ressourceLoading.wine_template != true">
            <v-btn class="mx-6" v-if="ressourceLoading.wine_template != true" @click="sync('wine_template')">Sync Wine Templates</v-btn>
            <span v-if="Number.isInteger(ressourceLoading.wine_template)">Synced : {{ressourceLoading.wine_template }}</span>
          </v-row>
          <v-progress-circular
            v-else
            class="mx-6"
            indeterminate
            :size="20"
            :width="3"
            color="secondary"
          ></v-progress-circular>
        </v-row>
      </v-col>
    </div>
  </div>
</template>

<script>
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST,
      ressourceLoading: {abandonned_checkout: false, ambassador: false, appellation: false, country: false, company: false, domain: false, 
      discount_code: false, grape: false, grape_variety: false, legal_entity_type: false, order: false, region: false, super_ambassador: false,
      user: false,  wine: false, wine_template: false}
    }
  },
  name: 'Algolia',
  methods: {
    /**
     * available indexes to xync :
     * abandonned_checkout, ambassador, appellation, country, company, domain, discount_code, grape, grape_variety, 
     * legal_entity_type, order, region, super_ambassador, user,  wine, wine_template
     */
    async sync(ressourceType) {
      try {
        if (!this.ressourceLoading[ressourceType]) {
          this.ressourceLoading[ressourceType] = true
          this.authToken = await this.$auth.getTokenSilently();
          const reqSync = await fetch(`${this.APIbaseURL}/algolia/synchronize/${ressourceType}`, {
            method: "POST",
            headers: {
              "Authorization": `Bearer ` + this.authToken
            }
          })

          let syncedData = await reqSync.json();

          this.ressourceLoading[ressourceType] = syncedData['ressource-count']

          this.$toastr.Add({
            title: "Algolia",
            msg: `${ressourceType} sync finished \n ${syncedData['ressource-count']} synced`,
            type: "info",
            timeout: 3600000 
          });
        }
      } catch (errors) {
        errorHandler(errors, this)
      }
    }
  },
}
</script>
